module.exports = __webpack_public_path__ + "img/c-thermometer-img1-2.2283962f.png";